import React, { useState, useEffect } from 'react'
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import usePostDataToServer from '../../hooks/usePostDataToServer';
import Spinner from '../../components/spinner';
import useGetDataFromServer from '../../hooks/useGetDataFromServer';
import EditIcon from '@mui/icons-material/Edit';
import FloorSection from './FloorSection';
import Errors from '../errors';
import Pagination from '../../components/pagination';
import { checkIfEmpty } from '../../utility';

function WingsSection({ goBack, data, buildingId }) {
    let id = {
        screen_id: buildingId,
        screen: "WING",
        pageNo: 0,
        limit: 10,
    }
    const [wingId, setWingId] = useState()
    const [section, setSection] = useState(3);
    const { handleGetData, paramsObject, setGetListParams } = useGetDataFromServer("getBuildingList", id)

    const goToSection = (sectionNo, wingId) => {
        setSection(sectionNo);
        setWingId(wingId)
    }

    const handlePageClick = (val) => {
        let data = {
            ...paramsObject,
            pageNo: val.selected
        }
        setGetListParams(data)
    }

    return (<>
        {section === 3 && <>
            <div className=''>
                <div onClick={goBack}>
                    <IconButton>
                        <ArrowBackIcon />
                    </IconButton>
                </div>
            </div>
            <div className='text-2xl font-semibold flex justify-center'>
                <span >WINGS</span>
            </div>
            {handleGetData.isLoading ? <Spinner />
                : handleGetData?.data?.data <= 0 || checkIfEmpty(handleGetData?.data?.data) ? <div className="flex items-center justify-center h-96">
                    <p className="text-lg font-semibold">No Wings Available</p>
                </div> : handleGetData.isError ? <Errors errorObject={handleGetData?.error} inline />
                    : <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative mt-6">
                        <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                            <thead>
                                <tr className="text-left">
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                        Sr.no
                                    </th>
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                        Wing Name
                                    </th>
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                        Total Floor
                                    </th>
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {handleGetData?.data?.data?.map((wingData, idx) => {
                                    const { wingId, wing_name, total_floors } = wingData
                                    return <tr key={idx}>
                                        <td className="border-dashed border-t border-gray-200 userId">
                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                                                {(paramsObject.limit * (paramsObject.pageNo + 1)) - (paramsObject.limit - (idx + 1))}
                                            </span>
                                        </td>
                                        <td className="border-dashed border-t border-gray-200 firstName">
                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">{wing_name}</span>
                                        </td>
                                        <td className="border-dashed border-t border-gray-200 firstName">
                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">{total_floors}</span>
                                        </td>
                                        <td className="border-dashed border-t border-gray-200 firstName">
                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm space-x-4 cursor-pointer">
                                                <span data-id='1'><EditIcon onClick={() => goToSection(4, wingId)} /></span>
                                            </span>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
            }
            <div className="my-7">
                <Pagination currentPage={paramsObject?.pageNo} pageCount={handleGetData?.data?.total_count} limit={paramsObject.limit} onPageChange={handlePageClick} />
            </div>
        </>}
        {section === 4 && <FloorSection data={handleGetData.data.data} wingId={wingId} goToWings={() => goToSection(3)} />}
    </>);
}

export default WingsSection;